// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import SponsoredImage from 'images/sponsored-icon-for-search.svg'

export default function SponsoredBadge () {
  return (
    <div
      data-tooltip
      className='pro-supplier-indicator body-x-small'
      tabIndex='2'
      title="This listing is a sponsored ad. Advertising with Procurated does not influence a supplier's organic search ranking or rating. For more on this, check out the Procurated Promise."
    >
      <img src={SponsoredImage} alt='Sponsored Supplier' />
      Sponsored
    </div>
  )
}
